import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useCallback } from 'react';
import { isTextSelection } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react';
import { useEditorContext } from '../EditorContext/EditorContext.js';
import { EditorSelectionMenuButtons } from './EditorSelectionMenuButtons.js';

/**
 * forked from https://github.com/ueberdosis/tiptap/blob/33420f4ae06d0d7eec16201a2e650be83cbb9de9/packages/extension-bubble-menu/src/bubble-menu-plugin.ts#L43
 *
 * This is a copy of the builtin BubbleMenu `shouldShow` function.
 * We use this in conjunction with !showLinkDialog && !disabled tests to enable
 * us to prevent the BubbleMenu from appearing when the editor is disabled or
 * when the LinkDialog is open.
 */
var ttShouldShow = function (_a) {
    var state = _a.state, from = _a.from, to = _a.to;
    var doc = state.doc, selection = state.selection;
    var empty = selection.empty;
    // Sometime check for `empty` is not enough.
    // Double-click an empty paragraph returns a node size of 2.
    // So we check also for an empty text size.
    var isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);
    if (empty || isEmptyTextBlock) {
        return false;
    }
    return true;
};
var EditorSelectionMenu = function (_a) {
    var setShowLinkDialog = _a.setShowLinkDialog, showLinkDialog = _a.showLinkDialog, props = __rest(_a, ["setShowLinkDialog", "showLinkDialog"]);
    var _b = useEditorContext(), editor = _b.editor, disabled = _b.disabled;
    var shouldShow = useCallback(function (shouldShowProps) {
        return !showLinkDialog && !disabled && ttShouldShow(shouldShowProps);
    }, [disabled, showLinkDialog]);
    return (jsx(BubbleMenu, __assign({ editor: editor, shouldShow: shouldShow, css: { display: showLinkDialog ? "none" : "block" } }, { children: jsx(EditorSelectionMenuButtons, __assign({ setShowLinkDialog: setShowLinkDialog, showLinkDialog: showLinkDialog }, props)) })));
};

export { EditorSelectionMenu };
//# sourceMappingURL=EditorSelectionMenu.js.map
